<div class="flex-column gap">
    <app-card [title]="headerTitle()">
        <ng-template #content>
            <div class="flex gap">
                <app-select-input
                    [id]="'serviceWorkgroupId'"
                    [form]="form"
                    class="flex-2 w-full"
                    label="folder.workgroups.fields.name"
                    [staticOptions]="store.workgroupOptions()"
                    [labelKey]="'name'"
                    [valueKey]="'id'"
                    [disabled]="!!form.value.id"
                ></app-select-input>
                <app-date-input
                    [form]="form"
                    class="flex-1"
                    id="validFrom"
                    prefix="folder.workgroups."
                ></app-date-input>
            </div>

            <div class="flex gap justify-content-end pt-4">
                @if (form.value.id) {
                    <app-cancel-button (clickEvent)="form.reset()"></app-cancel-button>
                }
                <app-save-button
                    [disabled]="form.untouched"
                    [label]="(form.value.id ? 'common.update' : 'common.assign')"
                    (clickEvent)="submit()"
                ></app-save-button>
            </div>
        </ng-template>
    </app-card>

    <app-card-table
        #folderWorkgroupTable
        [gridData]="store.data.getFolderWorkgroups()"
        [columns]="columns"
        [tableTitle]="'folder.workgroups.groups'"
        translatePrefix="folder.workgroups."
        [hideCheckboxes]="true"
        (detailCallback)="openUpdate($event)"
        (deleteCallbackWithEvent)="deleteFolderWorkgroup($event)"
        [refreshCallback]="filters.length? store.api.getFolderWorkgroups : null"
        [additionalFilter]="filters"
        [defaultSorters]="[{ column: 'validFrom', direction: 'DESC' }]"
    ></app-card-table>
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-cancel-button label="common.close" (clickEvent)="dialogRef.close()"></app-cancel-button>
</div>


